// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-installation":"Installation_dpu-detail-installation__qyyiP"};